import axios from '@/plugins/axios'
import { Module } from 'vuex'
import { sortCollection } from '@/utils/collections'

export interface Role {
    name: string,
    slug: string
}

const rolesModule: Module<any, any> = {
    actions: {
        async initRoleIndex(state: any) {
        	if (this.roleIndexLoading) {
        		await this.initRolePromise
        		return
        	}
            this.roleIndexLoading = true
            this.initRolePromise = this.dispatch('initIndex', {
                id: 'role',
                idField: 'id',
                indexedFields: ['name'],
                source: '/api/roles',
                store: [
                    '@id',
                    '@type',
                    'abilities',
                    'description',
                    'id',
                    'isBase',
                    'name',
                    'slug',
                ],
            })
            await this.initRolePromise
            this.roleIndexLoading = false
            this.initRolePromise = null
        },

        async getRoles(_, params) {
            const indexExists = await this.dispatch('indexExists', 'role')
            if (!indexExists || params?.refresh) {
                await this.dispatch('initRoleIndex')
            }

            const slugsFilter = (items) => {
                const filter = params?.slugs
                return filter
                    ? items?.filter((e) => filter.includes(e.slug))
                    : items
            }

            const sortName = (items) => {
                return sortCollection(items, 'name', params?.sortOrder?.toLowerCase() === 'asc')
            }

            const getSortOrder = () => {                
                return sortName
            }

            let records = null
            records = await this.dispatch('getRecords', {
                index: 'role',
                term: params?.search,
                fields: ['name', 'slug'],
                page: params?.page ?? 1,
                perPage: params?.perPage ?? 10,
                filters: [slugsFilter],
                sort: getSortOrder(),
            })

            return records            
        },

        /*
        async getRoles(_, params) {
            const { data } = await axios.get('/api/roles')
            return data
        },
        */

        async addRole(_, params) {
            await axios.post('/api/roles', params)
        },

        async editRole(_, params) {
            await axios.put(`/api/roles/${params.id}/update`, params)
        },
        
        async deleteRole(_, id) {
            await axios.delete(`/api/roles/${id}`)
        },
    },
}

export default rolesModule
